import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { config } from '../helpers/configHelper';
import { api_url } from '../helpers/cartHelper';
import ProductFields from './ProductFields';

class NewProduct extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fields: config.product_fields,
            active_field: null,
            operation: 'add',
            search_value: '',
            auth_user: this.props.auth_user.user,
            products: [],
            productRow: null,
        };
    }

    handleChange = (event, inp = null) => {
        const field = inp ? inp : this.state.active_field;

        let val = (typeof event.target !== 'undefined') ? event.target.value : event;
        const fields = this.state.fields;

        let index = fields.findIndex(item => item.name === field);
        let row = fields[index];
        row.value = val;

        this.setState({ fields: fields });

    }

    showKeyboard = (event, handle = null) => {
        let target = event.target;
        this.setState({ active_field: target.name }, function () {
            if (typeof this.props.showKeyboard === 'function') {
                this.props.showKeyboard(1, handle, target);
            }
        });
    }

    saveProduct = () => {
        const fields = this.state.fields;
        let isValid = true;

        let data = {};
        fields.forEach(field => {
            field.classError = null;
            if (field.required && !field.value) {
                field.classError = "is-invalid";
                isValid = false;
            }
            if (field.value) {
                data[field.name] = field.value;
            }
        });

        this.setState({ fields: fields });

        if (isValid) {
            if (typeof this.props.reloadCart === 'function') {
                this.props.reloadCart(data, 'new-product');

                fields.forEach(field => { field.value = null; });
                this.setState({ fields: fields });

                this.props.history.push(`/categories`);
            }

        }
    }

    getActiveOperation = (op) => { return op === this.state.operation ? " active" : ""; }

    setActiveOperation = (operation) => {

        const fields = this.state.fields;
        fields.map(field => {
            field.value = '';
        });

        this.setState({
            operation: operation,
            productRow: null,
            products: [],
            fields: fields,
            search_value: '',
        });
    }

    changeSearchHandling = (event) => {
        let value = (typeof event.target !== 'undefined') ? event.target.value : event;
        this.setState({ search_value: value }, function () {
            const auth_user = this.state.auth_user;
            if (value) {
                fetch(api_url + `products/search/${value}?api_token=${auth_user.api_token}`)
                    .then(results => { return results.json(); })
                    .then(data => {
                        this.setState({
                            products: data.products
                        });
                    });
            }
        });
    }

    selectProduct = (product) => {
        const fields = this.state.fields;

        const mapping = {
            title: 'name',
            price_ht: 'price',
            tva: 'tva',
            code: 'code',
            reference: 'reference',
            description: 'description',
            stock: 'stock'
        };
        fields.map(field => {
            if (mapping[field.name]) {
                const value = product[mapping[field.name]];
                field.value = (value === null || value === undefined) ? '' : value;
            }
        });

        this.setState({
            fields: fields,
            productRow: product
        });
    }

    updateProduct = () => {
        const fields = this.state.fields;
        let isValid = true;

        let data = {};
        fields.forEach(field => {
            field.classError = null;
            if (field.required && (field.value === null || field.value === undefined || field.value === '')) {
                field.classError = "is-invalid";
                isValid = false;
            }
            if (field.value !== null && field.value !== undefined && field.value !== '') {
                data[field.name] = field.value;
            }
        });

        this.setState({ fields: fields });

        if (isValid) {
            const auth_user = this.state.auth_user;
            const productRow = this.state.productRow;
            if (productRow.id) {
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                };
                fetch(api_url + `products/update/${productRow.id}?api_token=${auth_user.api_token}`, requestOptions)
                    .then(results => { return results.json(); })
                    .then(resp => {
                        if (resp.success) {
                            alert('Modification a été effectuée avec succès');
                            this.setState({ productRow: null, search_value: '', products: [] });
                        } else if (resp.message) {
                            alert(resp.message);
                        }
                    });
            }
        }
    }

    deleteProduct = () => {
        if (window.confirm("Voulez-vous vraiment supprimer ce produit ?")) {
            const auth_user = this.state.auth_user;
            const productRow = this.state.productRow;
            if (productRow.id) {
                let data = {};
                data['id'] = productRow.id;
                const requestOptions = {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data)
                };
                fetch(api_url + `products/delete/${productRow.id}?api_token=${auth_user.api_token}`, requestOptions)
                    .then(results => { return results.json(); })
                    .then(resp => {
                        if (resp.success) {
                            alert('Suppression a été effectuée avec succès');
                            this.setState({ productRow: null, search_value: '', products: [] });
                        } else if (resp.message) {
                            alert(resp.message);
                        }
                    });
            }
        }
    }

    render() {
        const fields = this.state.fields;
        return (
            <React.Fragment>

                <div className='clearfix'>
                    <div className='btn-group btn-group-etat'>
                        <button type="button" className={`btn btn-light${this.getActiveOperation('add')}`} onClick={() => this.setActiveOperation('add')} >Ajouter un produit</button>
                        <button type="button" className={`btn btn-light${this.getActiveOperation('edit')}`} onClick={() => this.setActiveOperation('edit')} >Modifier un produit</button>
                    </div>
                </div>
                <br />

                {this.state.operation === 'add' ? (
                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className="home-title">- Ajouter un produit</h4>
                            <hr />
                        </div>
                        <ProductFields
                            fields={fields}
                            handleChange={this.handleChange}
                            showKeyboard={this.showKeyboard}
                        />
                        <div className="col-md-12">
                            <button type="button" className="btn btn-payment text-center" onClick={() => this.saveProduct()}>
                                Enregistrer
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className='row'>
                        <div className='col-md-12'>
                            <h4 className="home-title">- Modifier un produit</h4>

                            {!this.state.productRow ? (
                                <div className="mb-4">
                                    <hr />
                                    <input
                                        type="text"
                                        value={this.state.search_value}
                                        className="form-control border"
                                        placeholder="Recherche..."
                                        onChange={this.changeSearchHandling}
                                        onClick={(event) => this.showKeyboard(event, this.changeSearchHandling)}
                                    />
                                </div>
                            ) : ""}

                            {this.state.products.length && !this.state.productRow ? (
                                <table className="table">
                                    <tbody>
                                        {this.state.products.map(product =>
                                            <tr key={product.id}>
                                                <td>
                                                    <button type="button" className="btn btn-link" onClick={() => this.selectProduct(product)}>{product.name}</button>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                            ) : ""}
                            <hr />
                        </div>

                        {this.state.productRow ? (
                            <React.Fragment>
                                <ProductFields
                                    fields={fields}
                                    handleChange={this.handleChange}
                                    showKeyboard={this.showKeyboard}
                                />
                                <div className="col-md-12">
                                    <button type="button" className="btn btn-payment text-center" onClick={() => this.updateProduct()}>
                                        Modifier
                                    </button>
                                </div>
                                <div className="col-md-12">
                                    <button type="button" className="btn btn-danger text-center" onClick={() => this.deleteProduct()}>
                                        Supprimer
                                    </button>
                                </div>
                            </React.Fragment>
                        ) : ""}

                    </div>
                )}

            </React.Fragment >
        );
    }
}

export default withRouter(NewProduct);
